<div class="w-full flex flex-col items-center py-4">
    <div class="flex flex-col gap-[30px] w-full max-w-[632px] px-4">
        <!-- Back to overview button -->
        <button mat-button i18n class="text-app-global-primary mr-auto" routerLink="/settings/organizations">
            <mat-icon svgIcon="arrow-left"></mat-icon>
            Terug naar overzicht
        </button>

        <!-- Page title -->
        <div class="flex flex-col gap-1">
            <div class="flex items-center gap-4">
                <!-- Title -->
                <h1 i18n *ngIf="organizationId" class="text-[22px] font-semibold shrink-0">Organisatie configuratie</h1>

                <!-- Current organization name -->
                <p *ngIf="organization && breakpoint.sm.value"
                    class="text-[22px] px-[8px] py-[10px] bg-app-global-quaternary text-app-global-quaternary-contrast rounded-[5px] whitespace-nowrap text-ellipsis overflow-hidden">
                    {{organization.name}}
                </p>
            </div>
            <p class="text-base text-app-global-text-secondary mb-2" i18n>
                Technische configuratie voor het afstellen van Retrieval Augmented Generation en de werking van de
                chatbot. Wanneer optionele velden leeg zijn worden defaults van de database gebruikt.
            </p>
        </div>
        <!-- Base model chat settings -->
        <div class="w-full flex flex-col items-start justify-between gap-[15px]">
            <div class="flex flex-col gap-2">
                <p class="text-lg font-semibold shrink-0 min-w-[120px]" i18n>Base model instellingen</p>
                <p class="text-base text-app-global-text-secondary mb-2" i18n>
                    Specifieke instellingen voor chatten met het base LLM.
                </p>
            </div>
            <!-- Temperature -->
            <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                <div class="flex sm:flex-col gap-1 shrink-0 min-w-[120px]">
                    <p class="text-base" i18n>Base model temperature</p>
                    <p class="text-base text-app-global-text-secondary" i18n>(Optioneel)</p>
                </div>
                <mat-form-field class="grow w-full sm:max-w-[420px]">
                    <input matInput placeholder="0.2" type="number"
                        [formControl]="organisationFormGroup.controls.baseModelTemperature">
                    <mat-error *ngIf="organisationFormGroup.controls.baseModelTemperature.hasError('required')" i18n>
                        Veld is verplicht
                    </mat-error>
                    <mat-error *ngIf="organisationFormGroup.controls.baseModelTemperature.hasError('range')" i18n>
                        Kies een waarde tussen 0 en 1
                    </mat-error>
                </mat-form-field>
            </div>
            <!-- System prompt -->
            <div class="w-full flex flex-col items-start justify-between gap-2">
                <div class="flex gap-1 shrink-0 min-w-[120px]">
                    <p class="text-base" i18n>Base model system prompt</p>
                    <p class="text-base text-app-global-text-secondary" i18n>(Optioneel)</p>
                </div>
                <mat-form-field class="grow w-full">
                    <textarea matInput i18n-placeholder placeholder="System prompt voor chatten met base model"
                        cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="4"
                        cdkAutosizeMaxRows="7"
                        [formControl]="organisationFormGroup.controls.baseModelSystemPrompt"></textarea>
                    <mat-error i18n>Veld is verplicht</mat-error>
                </mat-form-field>
            </div>
        </div>

        <mat-divider></mat-divider>

        <!-- RAG settings -->
        <div class="w-full flex flex-col items-start justify-between gap-[15px]">
            <div class="flex flex-col gap-2">
                <p class="text-lg font-semibold shrink-0 min-w-[120px]" i18n>RAG instellingen</p>
                <p class="text-base text-app-global-text-secondary mb-2" i18n>
                    Technische instellingen voor Retrieval Augmented Generation (chatten met collecties).
                </p>
            </div>
            <!-- Max chunks LLM -->
            <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                <div class="flex sm:flex-col gap-1 shrink-0 min-w-[120px]">
                    <p class="text-base" i18n>Maximum chunks voor LLM</p>
                    <p class="text-base text-app-global-text-secondary" i18n>(Optioneel)</p>
                </div>
                <mat-form-field class="grow w-full sm:max-w-[380px]">
                    <input matInput placeholder="0.2" type="number"
                        [formControl]="organisationFormGroup.controls.maxChunksLLM">
                    <mat-error *ngIf="organisationFormGroup.controls.maxChunksLLM.hasError('required')" i18n>
                        Veld is verplicht
                    </mat-error>
                    <mat-error *ngIf="organisationFormGroup.controls.maxChunksLLM.hasError('range')" i18n>
                        Kies een valide waarde
                    </mat-error>
                </mat-form-field>
            </div>
            <!-- Add document name to chunks -->
            <div class="w-full flex flex-col items-start justify-between gap-2">
                <p class="text-base shrink-0 min-w-[120px]" i18n>Documentnaam in chunks</p>
                <mat-radio-group class="flex flex-col"
                    [formControl]="organisationFormGroup.controls.addDocumentNameToChunks">
                    <mat-radio-button [value]="true" i18n>Ja</mat-radio-button>
                    <mat-radio-button [value]="false" i18n>Nee</mat-radio-button>
                </mat-radio-group>
            </div>
            <p class="text-base font-semibold" i18n>Select chunks instellingen</p>
            <!-- select chunks min similarity-->
            <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                <div class="flex sm:flex-col gap-1 shrink-0 min-w-[120px]">
                    <p class="text-base" i18n>Chunks minimum similarity</p>
                    <p class="text-base text-app-global-text-secondary" i18n>(Optioneel)</p>
                </div>
                <mat-form-field class="grow w-full sm:max-w-[380px]">
                    <input matInput placeholder="0.2" type="number"
                        [formControl]="organisationFormGroup.controls.selectChunksMinSimilarity">
                    <mat-error *ngIf="organisationFormGroup.controls.selectChunksMinSimilarity.hasError('required')"
                        i18n>
                        Veld is verplicht
                    </mat-error>
                    <mat-error *ngIf="organisationFormGroup.controls.selectChunksMinSimilarity.hasError('range')" i18n>
                        Kies een valide waarde
                    </mat-error>
                </mat-form-field>
            </div>
            <!-- select chunks min reranker -->
            <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                <div class="flex sm:flex-col gap-1 shrink-0 min-w-[120px]">
                    <p class="text-base" i18n>Chunks minimum reranker</p>
                    <p class="text-base text-app-global-text-secondary" i18n>(Optioneel)</p>
                </div>
                <mat-form-field class="grow w-full sm:max-w-[380px]">
                    <input matInput placeholder="0.2" type="number"
                        [formControl]="organisationFormGroup.controls.selectChunksMinReranker">
                    <mat-error *ngIf="organisationFormGroup.controls.selectChunksMinReranker.hasError('required')" i18n>
                        Veld is verplicht
                    </mat-error>
                    <mat-error *ngIf="organisationFormGroup.controls.selectChunksMinReranker.hasError('range')" i18n>
                        Kies een valide waarde
                    </mat-error>
                </mat-form-field>
            </div>
            <!-- select chunks similarity margin -->
            <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                <div class="flex sm:flex-col gap-1 shrink-0 min-w-[120px]">
                    <p class="text-base" i18n>Chunks similarity margin</p>
                    <p class="text-base text-app-global-text-secondary" i18n>(Optioneel)</p>
                </div>
                <mat-form-field class="grow w-full sm:max-w-[380px]">
                    <input matInput placeholder="0.2" type="number"
                        [formControl]="organisationFormGroup.controls.selectChunksSimilarityMargin">
                    <mat-error *ngIf="organisationFormGroup.controls.selectChunksSimilarityMargin.hasError('required')"
                        i18n>
                        Veld is verplicht
                    </mat-error>
                    <mat-error *ngIf="organisationFormGroup.controls.selectChunksSimilarityMargin.hasError('range')"
                        i18n>
                        Kies een valide waarde
                    </mat-error>
                </mat-form-field>
            </div>
            <!-- select chunks min reranker -->
            <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                <div class="flex sm:flex-col gap-1 shrink-0 min-w-[120px]">
                    <p class="text-base" i18n>Chunks reranker margin</p>
                    <p class="text-base text-app-global-text-secondary" i18n>(Optioneel)</p>
                </div>
                <mat-form-field class="grow w-full sm:max-w-[380px]">
                    <input matInput placeholder="0.2" type="number"
                        [formControl]="organisationFormGroup.controls.selectChunksRerankerMargin">
                    <mat-error *ngIf="organisationFormGroup.controls.selectChunksRerankerMargin.hasError('required')"
                        i18n>
                        Veld is verplicht
                    </mat-error>
                    <mat-error *ngIf="organisationFormGroup.controls.selectChunksRerankerMargin.hasError('range')" i18n>
                        Kies een valide waarde
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Title generation settings -->
        <div class="w-full flex flex-col items-start justify-between gap-[15px]">
            <div class="flex flex-col gap-2">
                <p class="text-lg font-semibold shrink-0 min-w-[120px]" i18n>Title generation</p>
            </div>
            <!-- System prompt -->
            <div class="w-full flex flex-col items-start justify-between gap-2">
                <div class="flex gap-1 shrink-0 min-w-[120px]">
                    <p class="text-base" i18n>Title generation system prompt</p>
                    <p class="text-base text-app-global-text-secondary" i18n>(Optioneel)</p>
                </div>
                <mat-form-field class="grow w-full">
                    <textarea matInput i18n-placeholder placeholder="System prompt voor title generation"
                        cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="4"
                        cdkAutosizeMaxRows="7"
                        [formControl]="organisationFormGroup.controls.titleGenerationSystemPrompt"></textarea>
                    <mat-error i18n>Veld is verplicht</mat-error>
                </mat-form-field>
            </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Cancel / Save -->
        <div class="flex justify-end gap-5 items-center">
            <div class="flex items-center gap-5">
                <button mat-button class="text-app-global-text-secondary" routerLink="/settings/organizations" i18n>
                    Annuleren
                </button>
                <button mat-flat-button color="secondary" (click)="updateOrganization()" i18n>
                    Opslaan
                </button>
            </div>
        </div>
    </div>
</div>